import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';


export interface State {
    id: string;
    state_name: string;
    state_country: string;
    status: number;

}
@Injectable({
  providedIn: 'root'
})
export class StateService {

  constructor(private  httpClient: HttpClient) {
  }

  getStates() {
    return this.httpClient.get('/systemconfig/state/');
  }


  /////////////////old url///////////////////////
  getState(id) {
    return this.httpClient.get(`/systemconfig/state/${id}/`);
  }

  getNewStates(id){
    return this.httpClient.get('/systemconfig/states/',{params: { id:id}})
  }

  postState(state) {
    return this.httpClient.post('/systemconfig/state/', state);
  }

  //////////////////////old url///////////////
  updateState(id, state) {
    return this.httpClient.patch(`/systemconfig/state/${id}/`, state);
  }

  updateStates(state){
    return this.httpClient.post('/systemconfig/states/',state)
  }
  postStatefile(file) {
    return this.httpClient.post('/systemconfig/importstate/', file);
  }
  checkState(state){
    return this.httpClient.get('/systemconfig/checkstate/?state='+ state);
  }

}
